import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n\t\t\tquery query {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\tproductType\n\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t  options {\n\t\t\t\t\t\t    id\n\t\t\t\t\t\t    name\n\t\t\t\t\t\t    values\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  variants(first:100) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        id \n\t\t\t\t\t\t        title\n\t\t\t\t\t\t        priceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        compareAtPriceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        availableForSale\n\t\t\t\t\t\t        selectedOptions {\n\t\t\t\t\t\t          name\n\t\t\t\t\t\t          value\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        image {\n\t\t\t\t\t\t          altText\n\t\t\t\t\t\t          thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t          productImg: transformedSrc(maxWidth:800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:50) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 485, crop: CENTER)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t'], ['\n\t\t\tquery query {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\tproductType\n\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t  options {\n\t\t\t\t\t\t    id\n\t\t\t\t\t\t    name\n\t\t\t\t\t\t    values\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  variants(first:100) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        id \n\t\t\t\t\t\t        title\n\t\t\t\t\t\t        priceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        compareAtPriceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        availableForSale\n\t\t\t\t\t\t        selectedOptions {\n\t\t\t\t\t\t          name\n\t\t\t\t\t\t          value\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        image {\n\t\t\t\t\t\t          altText\n\t\t\t\t\t\t          thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t          productImg: transformedSrc(maxWidth:800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:50) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 485, crop: CENTER)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t']);

import React, { Component } from 'react';
import { Query, compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';

// display components
import FeatureGallery from '../gallery/feature_gallery';
import CTABanner from '../cta_banner/cta_banner';
import AddProductForm from '../forms/add_product_form';
import RecommendedProducts from '../recommended_products/recommended_products';
import ExpandableBlock from '../expandable_block/expandable_block';
import Testimonials from '../testimonials/testimonials';
import Variant from './variant';
import { getInitialSelectedOptions } from '../utilities';

import { createProductQuery } from '../queries';

import './product.css';

var _ref = React.createElement(
	'span',
	{ className: 'starting-at' },
	'Starting at:'
);

var _ref2 = React.createElement(
	'h2',
	null,
	'Description'
);

var _ref3 = React.createElement(
	'h2',
	null,
	'Configure Your Product'
);

var Product = function (_Component) {
	_inherits(Product, _Component);

	function Product() {
		_classCallCheck(this, Product);

		var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));

		_this.state = {
			testimonials: [],
			selectedOptions: {},
			selectedVariant: {
				priceV2: {}
			},
			product: {},
			quantity: "1"

		};
		_this.setInitialData = _this.setInitialData.bind(_this);
		_this.handleOptionChange = _this.handleOptionChange.bind(_this);
		_this.updateValue = _this.updateValue.bind(_this);
		return _this;
	}

	_createClass(Product, [{
		key: 'createProductQuery',
		value: function createProductQuery(handle) {
			return gql(_templateObject, handle);
		}

		// TODO - refactor this to use this one and the one in kit builder as the same method in utilities

	}, {
		key: 'parseProductDescriptionDetails',
		value: function parseProductDescriptionDetails(description) {
			var details = description.split('[[PRODUCTDETAILS]]')[1];
			return details ? JSON.parse(details) : {};
		}
	}, {
		key: 'parseProductDescription',
		value: function parseProductDescription(description) {
			var desc = description.split('[[PRODUCTDETAILS]]')[0];
			return desc ? desc : "";
		}
	}, {
		key: 'setInitialData',
		value: function setInitialData(product) {
			var selectedVariant = product.variants.edges[0].node;
			this.setState({
				selectedOptions: getInitialSelectedOptions(product.options),
				selectedVariant: selectedVariant,
				product: product
			});
		}
	}, {
		key: 'handleOptionChange',
		value: function handleOptionChange(value, title) {
			var newSelectedOptions = Object.assign(Object.assign({}, this.state.selectedOptions), _defineProperty({}, title, value));
			this.setState({ selectedOptions: newSelectedOptions });
		}
	}, {
		key: 'getVariantForSelectedOptions',
		value: function getVariantForSelectedOptions(selectedOptions, variants) {
			return variants.find(function (variant) {
				console.log('varian', variant);
				return variant.node.selectedOptions.every(function (selectedOption) {
					return selectedOptions[selectedOption.name].trim() === selectedOption.value.trim();
				});
			}).node;
		}
	}, {
		key: 'updateValue',
		value: function updateValue(value, key) {
			this.setState(_defineProperty({}, key, value));
		}
	}, {
		key: 'totalPrice',
		value: function totalPrice(quantity, amount) {
			return parseInt(quantity) * parseFloat(amount);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.selectedOptions !== this.state.selectedOptions) {
				this.setState({ selectedVariant: this.getVariantForSelectedOptions(this.state.selectedOptions, this.state.product.variants.edges) });
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			this.setInitialData(this.props.product);
			fetch('/pages/testimonials').then(function (res) {
				return res.text();
			}).then(function (data) {
				var testimonials = JSON.parse(data.split('[[START]]')[1].split('[[END]]')[0]).testimonials.filter(function (item) {
					return item.product === _this2.props.handle;
				});
				_this2.setState({
					testimonials: testimonials
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var product = this.props.product;

			var product_details = this.parseProductDescriptionDetails(product.description);
			var description = this.parseProductDescription(product.description);
			return React.createElement(
				'div',
				{ className: 'simple-product' },
				React.createElement(
					'header',
					{ className: 'wrapper' },
					React.createElement(
						'div',
						null,
						React.createElement(
							'h1',
							null,
							product.title
						),
						React.createElement(
							'h2',
							null,
							product.productType
						)
					),
					React.createElement(
						'div',
						{ className: 'price' },
						React.createElement(
							'span',
							null,
							_ref,
							' ',
							React.createElement(
								'span',
								null,
								React.createElement(
									'strong',
									null,
									'$',
									Number(product.priceRange.minVariantPrice.amount).toFixed(0)
								),
								product.priceRange.minVariantPrice.currencyCode
							)
						)
					)
				),
				React.createElement(FeatureGallery, {
					images: product.images.edges
				}),
				React.createElement(CTABanner, {
					cta: product_details.cta
				}),
				React.createElement(
					'div',
					{ className: 'wrapper-small' },
					_ref2,
					React.createElement(
						'p',
						null,
						description
					)
				),
				product_details.blocks.map(function (block, i) {
					return React.createElement(ExpandableBlock, {
						key: 'block-' + i,
						block: block,
						testimonials: block.testimonials ? _this3.state.testimonials : []
					});
				}),
				React.createElement(
					'div',
					{ className: 'wrapper-small' },
					_ref3,
					React.createElement(
						'p',
						null,
						product_details.configure
					),
					product.options.map(function (option) {
						return React.createElement(Variant, {
							option: option,
							handleOptionChange: _this3.handleOptionChange,
							selectedOptions: _this3.state.selectedOptions
						});
					})
				),
				React.createElement(AddProductForm, {
					disclaimer: product_details.disclaimer,
					updateValue: this.updateValue,
					quantity: this.state.quantity,
					totalPrice: this.totalPrice(this.state.quantity, this.state.selectedVariant.priceV2.amount),
					selectedVariantId: this.state.selectedVariant.id,
					currency: product.priceRange.minVariantPrice.currencyCode
				}),
				React.createElement(RecommendedProducts, {
					products: product_details.recommended_products
				})
			);
		}
	}]);

	return Product;
}(Component);

export default Product;

// onCompleted={data => this.setInitialData(data)}